/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Meeting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Response object containing a list of the ids of meetings where the current user has not confirmed their attendance.
 * @export
 * @interface UnConfirmedMeetingAttendanceResponse
 */
export interface UnConfirmedMeetingAttendanceResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof UnConfirmedMeetingAttendanceResponse
     */
    meetingIds: Array<string>;
}

export function UnConfirmedMeetingAttendanceResponseFromJSON(json: any): UnConfirmedMeetingAttendanceResponse {
    return UnConfirmedMeetingAttendanceResponseFromJSONTyped(json, false);
}

export function UnConfirmedMeetingAttendanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnConfirmedMeetingAttendanceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meetingIds': json['meetingIds'],
    };
}

export function UnConfirmedMeetingAttendanceResponseToJSON(value?: UnConfirmedMeetingAttendanceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meetingIds': value.meetingIds,
    };
}


